import { CourseFormatEnum } from '@/models/Course';
import { useTranslation } from 'react-i18next';
import { Badge } from '../ui/daisy';
import { Colors } from '../ui/types';

type CourseFormatProps = {
  color: Colors;
  tKey: string;
};

const courseformats: Record<CourseFormatEnum, CourseFormatProps> = {
  [CourseFormatEnum.IN_PERSON]: {
    color: 'secondary',
    tKey: 'courseFormats.IN_PERSON',
  },
  [CourseFormatEnum.ONLINE]: {
    color: 'primary',
    tKey: 'courseFormats.ONLINE',
  },
  [CourseFormatEnum.SCHOOL]: {
    color: 'success',
    tKey: 'courseFormats.SCHOOL',
  },
  [CourseFormatEnum.EXTRA_COURSE]: {
    color: 'warning',
    tKey: 'courseFormats.EXTRA_COURSE',
  },
  [CourseFormatEnum.SELF_PACED]: {
    color: 'info',
    tKey: 'courseFormats.SELF_PACED',
  },
};

type CourseFormatBadgeProps = {
  format: CourseFormatEnum;
};

export default function CourseFormatBadge({ format }: CourseFormatBadgeProps) {
  const { t } = useTranslation('translation');

  const badgeProps = (format: CourseFormatEnum) => {
    return courseformats[format];
  };

  return (
    <Badge variant="default" color={badgeProps(format).color} size="md">
      {t(`${badgeProps(format).tKey}`)}
    </Badge>
  );
}
